import {
  AiOutlineFacebook,
  AiOutlineIdcard,
  AiOutlineIssuesClose,
  AiOutlineSetting,
  AiOutlineTeam,
} from 'react-icons/ai';
import {
  MdCardMembership,
  MdContactPhone,
  MdLowPriority,
  MdModelTraining,
  MdOutlineBusinessCenter,
  MdOutlineCategory,
  MdOutlineEngineering,
  MdOutlineHowToVote,
  MdOutlinePhoneCallback,
  MdOutlineSupportAgent,
  MdSupportAgent,
} from 'react-icons/md';

// import { AppTypes } from 'config/global-enums';
import { RiAdminLine } from 'react-icons/ri';
import { IoColorPaletteOutline, IoBookOutline } from 'react-icons/io5';
import { BiStore } from 'react-icons/bi';
import { BsEnvelopeOpen } from 'react-icons/bs';
import { BsShieldCheck, BsPersonVcard, BsTranslate } from 'react-icons/bs';
import { GiLevelEndFlag } from 'react-icons/gi';
import { GrStatusUnknown } from 'react-icons/gr';
import { RiSecurePaymentLine } from 'react-icons/ri';
import { SiChatbot } from 'react-icons/si';
import { getUserType } from 'utils/local-storage/user';

export const citizenPathText = () => {
  switch (getUserType()) {
    // case AppTypes.BUSINESS:
    //   return 'customers';

    // default:
    //   return 'citizens';
    default:
      return 'customers';
  }
};

export const SettingsSubMenuRoutes = {
  DEFAULT: '/account-settings',
  DEFAULT_ADMIN: '/account/linked-accounts',
  TEAM_INVITATIONS: '/team/invitations',
  TEAM_LIST: '/team/list',
  CUSTOMERS_INVITATIONS: `/customer/invitations`,
  CUSTOMERS_LIST: `/customer/list`,
  SUPPORT_COMPLAINT_CATEGORIES: '/support/issue-categories',
  SUPPORT_STATUS: '/support/ticket-status',
  SUPPORT_CALLBACK_STATUS: '/support/callback-status',
  AGENT_AVAILABILITY_STATUS: '/support/availability-status',
  LEAD_MANAGEMENT_STATUS: '/carma/lead-management-status',
  LEAD_SOURCES: '/customer-assist/lead-sources',
  SUPPORT_PRIORITY: '/support/priority',
  SUPPORT_SKILL: '/support/skills',
  SUPPORT_TIER: '/support/tiers',
  SUPPORT_AGENTS: '/support/agents',
  SUPPORT_SLA_SETTINGS: '/support/sla-settings',
  SUPPORT_LANGUAGE_SETTINGS: '/support/language-settings',
  SUPPORT_ASSISTANT_SETTINGS: '/support/assistant-settings',
  LINKED_ACCOUNTS: '/account/linked-accounts',
  ACCOUNT_DEPTS: '/account/departments',
  TEAM_DESIGNATIONS: '/team/designations',
  ACCOUNT_BRANCHES: '/account/branches',
  ACCOUNT_APPEARANCE: '/account/appearance',
  PARTNER_ACCOUNTS: '/account/partner-accounts',
  ACCOUNT_SETTINGS: '/account/regional-settings',
  PAYMENT_SETTINGS: '/payment-settings',
  INTEGRATION_SOCIAL_SETTINGS: '/integrations/social-settings',
  SETTINGS_VIEW: '/view',
  ADMIN_USERS: '/team/admin-users',
  ATTENDANCE_MANAGEMENT: '/team/attendance',
  FINE_TUNING: '/ml-vault/fine-tuning',
  TRAIN_AI: '/ai-training',
  APP_CREDENTIAL: '/credentials',
  BILLING_SUBSCRIPTION: '/billing/subscription',
  BILLING_INVOICES: '/billing/invoices',
  BILLING_RECEIPTS: '/billing/receipts',
  SESSION_MANAGEMENT: '/billing/session-management',
  BILLING_AND_PAYMENT: '/billing/billing-and-payment',
  BILLING_PAYMENT_DETAILS: '/billing/payment-method',
  INTEGRATED_APPS: '/integrated-apps-in',
  AI_ASSISTANT_FUNCTIONS: '/ai-assistant/functions',
  AI_ASSISTANT_MENU: '/ai-assistant/menu',
  AI_ASSISTANT_THEME: '/ai-assistant/theme',
  SHARE_LINK_SETTINGS: '/share',
  SETUP_SETTINGS: '/setup',
  PAYMENT_METHOD_SETTINGS: '/e-commerce/payments-method-setting',
  CREDIT_TERMS: '/e-commerce/credit-terms',
  ORDER_STATUS: '/e-commerce/order-status',
  UNITS: '/product-settings/units',
  TAX: '/product-settings/tax',
  CATEGORIES: '/product-settings/categories',
  BRANDS: '/product-settings/brands',
  PRODUCTS: '/product-settings/products',
  CATALOGS: '/product-settings/catalogs',
  QR_BATCH_LIST: '/qr/batch/list',
  QR_BATCH_CODE_LIST: '/qr/code/list',
  QR_HISTORY: '/qr/history',
  JOBS_SETTINGS: '/jobs/jobs-list',
  JOBS_APPLICATIONS_SETTINGS: '/jobs/jobs-applications',
  JOBS_INTERVIEW_SETTINGS: '/jobs/jobs-interview',
  LOYALTY_TIERS: '/loyalty/loyalty-tiers',
  LOYALTY_HISTORY: '/loyalty/earnings/loyalty-history',
  TAX_HISTORY: '/loyalty/earnings/tax-history',
  LOYALTY_ADJUSTMENTS: '/loyalty/earnings/loyalty-adjustments',
  LOYALTY_OVERVIEW: '/loyalty/loyalty-overview',
  LOYALTY_PROGRAM: '/loyalty/earnings/loyalty-programs',
  LOYALTY_DEFAULT_FIELD_VALUES: '/loyalty/loyalty-default-settings',
  CUSTOMER_LIFE_CYCLE: '/customer-assist/lead-lifecycle',
  CUSTOMER_RELATIONSHIP_TYPE: '/customer-assist/relationship-type',
  PARTNER_RELATIONSHIP_TYPE: '/partner-assist/relationship-type',
  PARTNER_LIFE_CYCLE: '/partner-assist/lead-lifecycle',
  GEO_MANAGEMENT: '/account/geo-management',
  BUSINESS_UNIT: '/account/business-unit',
  PRM: '/partner-assist/prm',
  USER_ROLES: '/user-role',
  WELCOME_KIT: '/welcome-kit',
  FIELD_SALES_OFFICERS: '/field-assist/field-sales-officers',
  FIELD_SUPPORT_OFFICERS: '/field-assist/field-support-officers',
  BANNERS: '/banners',
  PARTNER_CLIENT_INVITE: '/partner-assist/invitations',
  CUSTOMER_CLIENT_INVITE: '/customer-assist/invitations',
  REDEMPTION_CATALOG: '/loyalty/redemption/catalog',
  REDEMPTION_CATEGORY: '/loyalty/redemption/category',
  REDEMPTION_ITEMS: '/loyalty/redemption/items',
  REDEMPTION_REWARD_HISTORY: '/loyalty/redemption/reward-history',
  REDEMPTION_REWARD_REJECT_REASONS: '/loyalty/redemption/reward-reject-reasons',
  PRODUCT_HISTORY: '/loyalty/earnings/product-history',
  SUPPLIER_LOGS: '/loyalty/redemption/supplier-logs',
  TARGET_TYPES: '/sales/target/types',
  TARGET_REWARD_TYPES: '/sales/target/reward-types',
  REWARD_CONFIG: '/sales/target/reward-config',
  TARGET_PROGRAM: '/sales/target/program',
  TARGET_ASSIGNMENT: '/sales/target/assignment',
  ROLE_SETTINGS: '/app-management/role-settings',
};

export const accountsMenuItems = [
  {
    key: 'basic_info',
    webPath: '/settings' + SettingsSubMenuRoutes.LINKED_ACCOUNTS,
    label: 'Organisation',
    // description: 'Manage essential organisation details and settings',
    icon: <MdOutlineBusinessCenter />,
  },
  {
    key: 'departments',
    webPath: '/settings' + SettingsSubMenuRoutes.ACCOUNT_DEPTS,
    label: 'Departments',
    // description:
    //   'Effectively manage organisation units with the Department menu.',
    icon: <MdOutlineCategory />,
  },
  // {
  // key: '',
  //   webPath: '/settings' + SettingsSubMenuRoutes.SETTINGS_VIEW,
  //   label: 'Branches',
  //   description: 'Manage your organisation locations with the Branch menu.',
  //   icon: <AiOutlineBranches />,
  // },
  // {
  // key: '',
  //   webPath: '/settings' + SettingsSubMenuRoutes.SETTINGS_VIEW,
  //   label: 'Zones',
  //   description:
  //     'Access and modify information about geographical Zones with ease.',
  //   icon: <BsPinMap />,
  // },
  {
    key: 'account_settings',
    webPath: '/settings' + SettingsSubMenuRoutes.ACCOUNT_SETTINGS,
    label: 'Account Settings',
    // description: 'Easily manage language, date, time, and other settings.',
    icon: <AiOutlineSetting />,
    isForNonAdmin: true,
  },
  // {
  //   key: 'payment_settings',
  //   webPath: '/settings' + SettingsSubMenuRoutes.PAYMENT_SETTINGS,
  //   label: 'Subscriptions & Billing',
  //   description:
  //     'Administer your subscription and wallet balance for SMS and WhatsApp messaging.',
  //   icon: <RiSecurePaymentLine />,
  // },
  {
    key: 'appearance_settings',
    webPath: '/settings' + SettingsSubMenuRoutes.ACCOUNT_APPEARANCE,
    label: 'Appearences',
    // description: `Organize themes according to your business's colors, logo, and branding elements.`,
    icon: <IoColorPaletteOutline />,
  },
];

export const helpdeskMenuItems = [
  {
    key: 'support_complaint_categories',
    webPath: '/settings' + SettingsSubMenuRoutes.SUPPORT_COMPLAINT_CATEGORIES,
    label: 'Complaint Categories',
    // description:
    //   'Categorising complaints enables routing to specialised agents for resolution.',
    icon: <AiOutlineIssuesClose />,
  },
  {
    key: 'support_agents',
    webPath: '/settings' + SettingsSubMenuRoutes.SUPPORT_AGENTS,
    label: 'Agents',
    // description:
    //   'Administer agents and categorise complaints for efficient management.',
    icon: <MdSupportAgent />,
  },
  // {
  //   key: '',
  //   webPath: '/settings' + SettingsSubMenuRoutes.SUPPORT_SKILL,
  //   label: 'Skills',
  //   description:
  //     'Automatically match tickets to skilled agents based on expertise.',
  //   icon: <MdOutlineEngineering />,
  // },
  // {
  //   key: '',
  //   webPath: '/settings' + SettingsSubMenuRoutes.SUPPORT_TIER,
  //   label: 'Tiers',
  //   description:
  //     'Effortlessly manage support tiers - assign and customise support levels for your agents. Streamline issue resolution and improve satisfaction.',
  //   icon: <GiLevelEndFlag />,
  // },
  {
    key: 'support_status',
    webPath: '/settings' + SettingsSubMenuRoutes.SUPPORT_STATUS,
    label: 'Ticket Status',
    // description: 'List of ticket statuses and its details.',
    icon: <GrStatusUnknown />,
  },
  {
    key: 'callback_status',
    webPath: '/settings' + SettingsSubMenuRoutes.SUPPORT_CALLBACK_STATUS,
    label: 'Callback Status',
    // description: 'Configure callback options for customer convenience.',
    icon: <MdOutlinePhoneCallback />,
  },
  {
    key: 'lead_sources',
    webPath: '/settings' + SettingsSubMenuRoutes.LEAD_SOURCES,
    label: 'Lead sources',
    // description: 'Lorem ipsum dolor sit amet, consectetur adipiscing.',
    icon: <MdContactPhone />,
  },
  {
    key: 'lead_management_status',
    webPath: '/settings' + SettingsSubMenuRoutes.LEAD_MANAGEMENT_STATUS,
    label: 'Lead Management Status',
    // description: 'Lorem ipsum dolor sit amet, consectetur adipiscing.',
    icon: <MdContactPhone />,
  },
  // {
  //   key: 'support_priority',
  //   webPath: '/settings' + SettingsSubMenuRoutes.SUPPORT_PRIORITY,
  //   label: 'Priority',
  //   description: 'List of priorities of the tickets and their details.',
  //   icon: <MdLowPriority />,
  // },
  // {
  //   key: 'support_sla_settings',
  //   webPath: '/settings' + SettingsSubMenuRoutes.SUPPORT_SLA_SETTINGS,
  //   label: 'SLA Policies',
  //   description:
  //     'Service level agreement: Manage agreed response time for customer service requests.',
  //   icon: <BsShieldCheck />,
  // },
  {
    key: 'support_language_settings',
    webPath: '/settings' + SettingsSubMenuRoutes.SUPPORT_LANGUAGE_SETTINGS,
    label: 'Language Settings',
    // description:
    //   'Select the languages you wish to support for the conversational AI.',
    icon: <BsTranslate />,
  },
  {
    key: 'support_assistant_settings',
    webPath: '/settings' + SettingsSubMenuRoutes.SUPPORT_ASSISTANT_SETTINGS,
    label: 'Assistant Settings',
    // description:
    //   'Create and manage your AI Assistants with distinct names and avatars.',
    icon: <SiChatbot />,
  },
];

export const teamMenuItems = [
  {
    key: 'team_list',
    webPath: '/settings' + SettingsSubMenuRoutes.TEAM_LIST,
    label: 'Team Members',
    // description: 'Administer team member access to this system.',
    icon: <AiOutlineTeam />,
  },
  // {
  //   key: 'team_invitations',
  //   webPath: '/settings' + SettingsSubMenuRoutes.TEAM_INVITATIONS,
  //   label: 'Invite Team Members',
  //   description: 'Send  invites to your team members to join.',
  //   icon: <AiOutlineIdcard />,
  // },
  // {
  //   key: 'support_agents',
  //   webPath: '/settings' + SettingsSubMenuRoutes.SUPPORT_AGENTS,
  //   label: 'Agents',
  //   description:
  //     'Administer agents and categorise complaints for efficient management.',
  //   icon: <MdOutlineSupportAgent />,
  // },
  {
    key: 'admin_users',
    webPath: '/settings' + SettingsSubMenuRoutes.ADMIN_USERS,
    label: 'Admin Users',
    // description:
    //   'Assign administrative privileges to users, granting them full permissions on the platform.',
    icon: <RiAdminLine />,
  },
  // {
  // key: '',
  //   webPath: '/settings' + SettingsSubMenuRoutes.SETTINGS_VIEW,
  //   label: 'Rooms',
  //   description:
  //     'Rooms are manageable groups for team members to convene and communicate.',
  //   icon: <HiOutlineUserGroup />,
  // },
];

export const integrationMenuItems = [
  {
    key: 'integration_social_settings',
    webPath: '/settings' + SettingsSubMenuRoutes.INTEGRATION_SOCIAL_SETTINGS,
    label: 'Facebook',
    // description:
    //   'Link your Facebook page to fetch customer posts, comments, and messages as support requests.',
    icon: <AiOutlineFacebook />,
  },
  // {
  // key: '',
  //   webPath: '/settings' + SettingsSubMenuRoutes.SETTINGS_VIEW,
  //   label: 'WhatsApp',
  //   description:
  //     'Incorporate your WhatsApp business number to assist customers and provide prompt solutions.',
  //   icon: <AiOutlineWhatsApp />,
  // },
  // {
  // key: '',
  //   webPath: '/settings' + SettingsSubMenuRoutes.SETTINGS_VIEW,
  //   label: 'Email',
  //   description:
  //     'Incorporate support email accounts, set up DKIM, personalized mail servers, Bcc, and additional features.',
  //   icon: <AiOutlineMail />,
  // },
];
export const MlVaultMenuItems = [
  {
    key: 'ai_training_settings',
    webPath: '/settings' + SettingsSubMenuRoutes.TRAIN_AI,
    label: 'AI Training',
    // description: 'lorem ipsum dolor sit amet, consectetur adipiscing elit',
    icon: <MdModelTraining />,
  },
  {
    key: 'fine_tuning_settings',
    webPath: '/settings' + SettingsSubMenuRoutes.FINE_TUNING,
    label: 'Fine Tuning',
    // description:
    //   'Utilize machine learning techniques by uploading files to train the AI system.',
    icon: <MdModelTraining />,
  },
];

export const citizenMenuItems = [
  {
    key: 'citizens_list',
    webPath: '/settings' + SettingsSubMenuRoutes.CUSTOMERS_LIST,
    label: 'Citizen',
    // description:
    //   'Citizen management made easy. Efficiently manage, track and monitor citizen activity.',
    icon: <MdOutlineHowToVote />,
  },
  {
    key: 'citizens_invitations',
    webPath: '/settings' + SettingsSubMenuRoutes.CUSTOMERS_INVITATIONS,
    label: 'Citizen Invite',
    // description:
    //   'Expand your network - invite citizens to join and connect. Grow your community and enhance collaboration.',
    icon: <BsEnvelopeOpen />,
  },
];

export const customerMenuItems = [
  {
    key: 'customers_list',
    webPath: '/settings' + SettingsSubMenuRoutes.CUSTOMERS_LIST,
    label: 'Customer',
    // description:
    //   'Customer management made easy. Efficiently manage, track and monitor customer activity.',
    icon: <BsPersonVcard />,
  },
  // {
  //   key: 'customers_invitations',
  //   webPath: '/settings' + SettingsSubMenuRoutes.CUSTOMERS_INVITATIONS,
  //   label: 'Customer Invite',
  //   description:
  //     'Expand your network - invite customers to join and connect. Grow your community and enhance collaboration.',
  //   icon: <BsEnvelopeOpen />,
  // },
];

export const membersMenuItems = [
  {
    key: 'members_list',
    webPath: '/settings' + SettingsSubMenuRoutes.CUSTOMERS_LIST,
    label: 'Members',
    // description:
    //   'Effortlessly manage  members. Keep track of membership details and communication for streamlined administration.',
    icon: <MdCardMembership />,
  },
  {
    key: 'members_invitations',
    webPath: '/settings' + SettingsSubMenuRoutes.CUSTOMERS_INVITATIONS,
    label: 'Members Invite',
    // description:
    //   'Expand your association network - invite members to join and collaborate. Grow your community and achieve more together.',
    icon: <BsEnvelopeOpen />,
  },
];

export const channelPartnersMenuItems = [
  {
    key: 'channel_partners_list',
    webPath: '/settings' + SettingsSubMenuRoutes.CUSTOMERS_LIST,
    label: 'Channel Partners',
    // description:
    //   'Efficiently manage channel partners - Distributors, Dealers, Retailers, and more. Streamline communication and boost sales performance.',
    icon: <BiStore />,
  },
  {
    key: 'channel_partners_invitations',
    webPath: '/settings' + SettingsSubMenuRoutes.CUSTOMERS_INVITATIONS,
    label: 'Channel Partners Invite',
    // description:
    //   'Expand your channel partner network - invite Distributors, Dealers, Retailers, and more. Collaborate and drive sales growth.',
    icon: <BsEnvelopeOpen />,
  },
];
